import React, { useRef, useEffect, useState } from 'react'
import styled from 'styled-components'
import PortableText from '@sanity/block-content-to-react'

const Description = styled.div`
  font-weight:100;
  margin-top:10em;
  margin-bottom:10em;
  font-size:var(--medium-text);
  font-family:var(--sans);
  /* margin-bottom:10em; */
  position:relative;
  z-index:2;
  background:var(--black);

  p{
    max-width:30em;

  }
`

export default function ProgramDescription ({ data }) {
  return (

    <Description>
      <PortableText blocks={data._rawProgramDescription} />
    </Description>
  )
}
